// utils/getBaseUrl.js
export const getBaseUrl = (requiresAuth = false) => {
  return requiresAuth
    ? process.env.REACT_APP_BASE_URL
    : process.env.REACT_APP_BASE_URL_WITHOUT_AUTH;
};
export const getBaseUrlMyVMS = () => {
  return process.env.REACT_APP_MYVMS
};